// D:\Workspace\paperplay\frontend\src\constants\routeSlugs.ts

export enum RouteSlug {
  // Core
  DASHBOARD = 'dashboard',
  PROFILE = 'profile',
  PAYMENTS = 'payments',
  BOOKINGS = 'bookings',
  MESSAGES = 'messages',
  MARKETPLACE = 'marketplace',
  GIGS = 'gigs',
  SUPPORT = 'support',
  LOGOUT = 'logout',
  FAVORITES = 'favorites',

  // --- NEW: org-scoped dashboards ---
  DASHBOARD_ARTIST = 'dashboard_artist',
  DASHBOARD_VENUE = 'dashboard_venue',
  DASHBOARD_HOST = 'dashboard_host',

  // Account-Settings
  ACCOUNT_USERPROFILE = 'account_userprofile',
  ACCOUNT_USERPROFILE_WITHID = 'account_userprofile_withid',
  ACCOUNT_PROFILEPAGE = 'account_profilepage',
  ACCOUNT_ACCOUNTDETAILS = 'account_accountdetails',
  ACCOUNT_MANAGEPREFERENCES = 'account_managepreferences',
  ACCOUNT_AUTHDEVICES = 'account_authdevices',
  ACCOUNT_BILLINGHISTORY = 'account_billinghistory',
  ACCOUNT_CONNECTEDACCOUNTS = 'account_connectedaccounts',
  ACCOUNT_FORGOTPASSWORD = 'account_forgotpassword',
  ACCOUNT_PASSWORD = 'account_password',
  ACCOUNT_SUBSCRIPTIONMANAGEMENT = 'account_subscriptionmanagement',
  ACCOUNT_TWOFACTORAUTH = 'account_twofactorauth',

  // Authorization
  AUTH_HOME = 'auth_home',
  AUTH_REGISTER = 'auth_register',
  AUTH_CHECK_EMAIL = 'auth_check_email',
  AUTH_VERIFY_ACCOUNT = 'auth_verify_account',
  AUTH_VERIFY_USER = 'auth_verify_user',
  AUTH_IMPERSONATION_BOOTSTRAP = 'auth_impersonation_bootstrap',
  AUTH_LOGIN = 'auth_login',
  AUTH_UNAUTHORIZED = 'auth_unauthorized',
  AUTH_PWRESET_REQUEST = 'auth_pwreset_request',
  AUTH_PWRESET_CHANGE = 'auth_pwreset_change',
  AUTH_PWRESET_FORGOT = 'auth_pwreset_forgot',
  AUTH_PWRESET_RESET = 'auth_pwreset_reset',
  AUTH_NOT_FOUND = 'auth_not_found',
  AUTH_PWRESET_SMS_CONFIRM = 'AUTH_PWRESET_SMS_CONFIRM',

  // Artist
  ARTIST_CONFIRMATION = 'artist_confirmation',
  ARTIST_CREATE = 'artist_create',
  ARTIST_DETAIL = 'artist_detail',
  ARTIST_PROFILE_WITHID = 'artist_profile_withid',
  ARTIST_PROFILE_ORG = 'artist_profile_org',
  ARTIST_LIST = 'artist_list',
  ARTIST_MEMBERSHIP = 'artist_membership',
  ARTIST_PROFILE_NOID = 'artist_profile_noid',

  // Public profile slugs
  PUBLIC_ARTIST_PROFILE_WITHID = 'public_artist_profile_withid',
  PUBLIC_ARTIST_PROFILE_BY_HANDLE = 'public_artist_profile_by_handle',
  PUBLIC_VENUE_PROFILE_WITHID = 'public_venue_profile_withid',
  ARTIST_BAND_INVITE_RESPONSE = 'artist_band_invite_response',
  ARTIST_BAND_LINKED_INVITE_RESPONSE = 'artist_band_linked_invite_response',

  // --- NEW: artist events dashboard (used by eventRoutes) ---
  ARTIST_EVENTS_DASHBOARD = 'artist_events_dashboard',

  // Booking
  ARTIST_BOOKINGS_DASHBOARD = 'artist_bookings_dashboard',
  VENUE_BOOKINGS_DASHBOARD = 'venue_bookings_dashboard',
  BOOKING_LIST = 'booking_list',
  BOOKING_DASHBOARD = 'booking_dashboard',
  BOOKING_CREATE = 'booking_create',
  BOOKING_DETAIL = 'booking_detail',
  BOOKING_UPDATE = 'booking_update',
  BOOKING_DELETE = 'booking_delete',
  BOOKING_COUNTER_OFFER = 'booking_counter_offer',
  BOOKING_NEGOTIATION = 'booking_negotiation',
  BOOKING_ANALYTICS = 'booking_analytics',
  BOOKING_PAGE = 'booking_page',

  // --- NEW: optional alias some routes use ---
  BOOKINGS_MARKETPLACE = 'bookings_marketplace',

  // Calendars
  CALENDAR_DASHBOARD = 'calendar_dashboard',
  CALENDAR_EVENT_LIST = 'calendar_event_list',
  CALENDAR_AVAILABILITY = 'calendar_availability',
  CALENDAR_EVENT_CREATE = 'calendar_event_create',
  CALENDAR_EVENT_EDIT = 'calendar_event_edit',
  CALENDAR_EVENT_DETAILS = 'calendar_event_details',
  CALENDAR_VENUE = 'calendar_venue',
  REPORTED_SHOW_CONFIRMATION = 'reported_show_confirmation',

  // Collaborators
  COLLABORATORS_MANAGE = 'collaborators_manage',
  COLLABORATORS_INVITE = 'collaborators_invite',
  COLLABORATOR_INVITE_ACCEPT = 'collaborator_invite_accept',
  COLLABORATOR_INVITE_REDEEM = 'collaborator_invite_redeem',

  // ✅ NEW: Event Collaborator Invite Accept
  EVENT_COLLABORATOR_INVITE_ACCEPT = 'event_collaborator_invite_accept',

  // Shareable invite links (/i/:code). Short because it is typed off a screen
  // and pasted into text messages, and the mobile app claims the same path.
  SHARE_INVITE = 'share_invite',

  COLLABORATORS_ROLES = 'collaborators_roles',
  COLLABORATORS_PERMISSIONS = 'collaborators_permissions',
  COLLABORATORS_AUDIT_LOG = 'collaborators_audit_log',

  // Communities
  COMMUNITIES = 'communities',
  MY_COMMUNITIES = 'communities_my',
  COMMUNITY_DETAIL = 'community_detail',
  COMMUNITY_INVITE_REDEEM = 'community_invite_redeem',
  COMMUNITY_CREATE = 'community_create',
  COMMUNITIES_SEARCH = 'communities_search',

  // --- NEW: community settings & join deeplinks ---
  COMMUNITY_SETTINGS = 'community_settings',
  COMMUNITY_JOIN = 'community_join',

  // Gig Terms / Templates
  GIGTERMS_INDEX = 'gigterms_index',
  GIGTERMS_MASTER = 'gigterms_master',
  GIGTERMS_VENUE = 'gigterms_venue',
  GIGTEMPLATES_LIST = 'gigstemplates_list',
  GIGTEMPLATES_CREATE = 'gigstemplates_create',
  GIGTEMPLATES_EDIT = 'gigstemplates_edit',
  GIGTEMPLATES_SERIES = 'gigstemplates_series',

  // --- NEW: venue-local template routes used in VenueRoutes ---
  VENUE_TEMPLATES_LIST = 'venue_templates_list',
  VENUE_TEMPLATES_CREATE = 'venue_templates_create',
  VENUE_CONTRACT_TERMS = 'venue_contract_terms',
  VENUE_OPEN_GIG = 'venue_open_gig',

  // Event
  EVENT_CREATE = 'event_create',
  EVENT_LIST = 'event_list',
  EVENT_DASHBOARD = 'event_dashboard',
  EVENT_DETAIL = 'event_detail',
  EVENT_EDIT = 'event_edit',
  EVENT_DELETE = 'event_delete',
  EVENT_COMPLETION = 'event_completion',
  EVENT_FACIAL_RECOGNITION = 'event_facial_recognition',
  EVENT_PITCH_VIEW = 'event_pitch_view',

  // --- NEW: venue event detail (used by eventRoutes) ---
  VENUE_EVENT_DETAIL = 'venue_event_detail',

  // Help and Support
  SUPPORT_HOME = 'support_home',
  SUPPORT_SUBMIT_REQUEST = 'support_submit_request',
  SUPPORT_FAQ = 'support_faq',
  SUPPORT_TRAINING = 'support_training',
  SUPPORT_TRAINING_AUDIENCE = 'support_training_audience',
  SUPPORT_REQUEST_DETAIL = 'support_request_detail',
  ADMIN_SUPPORT_REQUEST = 'admin_support_request',
  ADMIN_SUPPORT_FAQ = 'admin_support_faq',
  SUPPORT_REQUEST_LIST = 'support_request_list',

  // Payment
  ARTIST_PAYMENTS_DASHBOARD = 'artist_payments_dashboard',
  VENUE_PAYMENTS_DASHBOARD = 'venue_payments_dashboard',
  PAYMENT_DASHBOARD = 'payment_dashboard',
  PAYMENT_TRANSACTION_LIST = 'payment_transaction_list',
  PAYMENT_TRANSACTION_NEW = 'payment_transaction_new',
  PAYMENT_TRANSACTION_DETAIL = 'payment_transaction_detail',
  PAYMENT_TRANSACTION_UPDATE = 'payment_transaction_update',
  PAYMENT_TRANSACTION_DELETE = 'payment_transaction_delete',
  PAYMENT_REFUND = 'payment_refund',
  PAYMENT_REALTIME_REPORT = 'payment_realtime_report',
  PAYMENT_EXTERNAL_SYNC = 'payment_external_sync',
  PAYMENT_ANALYTIC_TRANSACTION = 'payment_analytic_transaction',
  PAYMENT_ANALYTICS = 'payment_analytics',
  PAYMENT_METHOD_LIST = 'payment_method_list',
  PAYMENT_METHOD_DETAIL = 'payment_method_detail',
  PAYMENT_METHOD_UPDATE = 'payment_method_update',
  PAYMENT_METHOD_DELETE = 'payment_method_delete',
  PAYMENT_CONDITION_UPDATE = 'payment_condition_update',
  PAYMENT_CONDITION_DELETE = 'payment_condition_delete',
  PAYMENT_SET_SPLIT = 'payment_set_split',
  PAYMENT_REGISTER_USER = 'payment_register_user',
  PAYMENT_PAYOUTS_INSTANT = 'PAYMENT_PAYOUTS_INSTANT',
  PAYMENT_PAYOUTS_HISTORY = 'PAYMENT_PAYOUTS_HISTORY',
  PAYMENT_PAYOUT_METHODS = 'PAYMENT_PAYOUT_METHODS',
  PAYMENT_DISPUTES = 'PAYMENT_DISPUTES',
  PAYMENT_EVENT_ROUTE = 'PAYMENT_EVENT_ROUTE',
  PAYMENT_EVENT_ESCROW = 'PAYMENT_EVENT_ESCROW',
  PAYMENT_EVENT_OVERTIME = 'PAYMENT_EVENT_OVERTIME',
  PAYMENT_EVENT_TIPS = 'PAYMENT_EVENT_TIPS',
  PAYMENT_EVENT_SPLIT = 'PAYMENT_EVENT_SPLIT',
  PAYMENT_EVENT_SUCCESS = 'PAYMENT_EVENT_SUCCESS',
  PAYMENT_EVENT_CXL_POLICY = 'PAYMENT_EVENT_CXL_POLICY',
  PAYMENT_CXL_POLICY = 'PAYMENT_CXL_POLICY',

  // Messages
  MESSAGES_ARTIST = 'messages_artist',
  MESSAGES_ARTIST_CHANNEL = 'messages_artist_channel',
  MESSAGES_ARTIST_CHANNEL_READRECEIPT = 'messages_artist_channel_readreceipt',
  MESSAGES_VENUE = 'messages_venue',
  MESSAGES_VENUE_CHANNEL = 'messages_venue_channel',
  MESSAGES_VENUE_CHANNEL_READRECEIPT = 'messages_venue_channel_readreceipt',
  MESSAGES_ACCOUNT = 'messages_account',
  MESSAGES_ACCOUNT_CHANNEL = 'messages_account_channel',
  MESSAGE_INDEX = 'message_index',
  CHANNEL_DETAIL = 'channel_detail',
  CHANNEL_MESSAGES = 'channel_messages',
  CHANNEL_READ_RECEIPT = 'channel_read_receipt',
  ADMIN_CHANNEL = 'admin_channel',
  ADMIN_MESSAGE = 'admin_message',
  CHANNEL_LIST = 'channel_list',

  // Venue
  VENUE_DETAIL = 'venue_detail',
  VENUE_EDIT = 'venue_edit',
  VENUE_CREATE = 'venue_create',
  VENUE_REGISTER = 'venue_register',
  VENUE_DASHBOARD = 'venue_dashboard',
  VENUE_PROFILE_WITHID = 'venue_profile_withid',
  VENUE_PROFILE_ORG = 'venue_profile_org',
  VENUE_LIST = 'venue_list',

  // Organization admin
  ORG_TEAM = 'org_team',
  ORG_ROLES = 'org_roles',

  // Notifications
  NOTIFICATIONS = 'notifications',

  // Host (new)
  HOST_GUEST_CHECKIN = 'host_guest_checkin',
  HOST_DASHBOARD = 'host_dashboard',
}
